import React from "react";
import { TableRow, TableCell, withStyles } from "@material-ui/core";

const colors = {
  statusHeadColor: "#E0F2EF",
  delayStatusHeadColor: "#F8D9D9",
  statusHeadFontColor: "#01917E",
  delayStatusHeadFontColor: "#CF0000",
};
const styles = {
  statusHead: {
    backgroundColor: colors.statusHeadColor,
  },
  delayStopStatusHead: {
    backgroundColor: colors.delayStatusHeadColor,
  },
  statusHeadHeight: {
    height: "24px",
  },
  statusHeaderCell: {
    color: colors.statusHeadFontColor,
    borderBottom: 0,
    fontSize: "12px",
    paddingLeft: "10px",
  },
  delayStopStatusHeaderCell: {
    color: colors.delayStatusHeadFontColor,
    borderBottom: 0,
    fontSize: "12px",
    paddingLeft: "10px",
  },
  customerName: {
    float: "left",
    paddingLeft: "10px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    fontWeight: 500,
    lineHeight: "17px",
    width: "130px",
    textOverflow: "ellipsis",
  },
};

const UnAssignPickup = ({ classes, unAssignDriver, stopData, isDelayStop }) => {
  return (
    <TableRow
      className={`${classes.statusHeadHeight} ${
        isDelayStop ? classes.delayStopStatusHead: classes.statusHead
      }`}
    >
      <TableCell
        colSpan={2}
        className={
          isDelayStop
            ? classes.delayStopStatusHeaderCell
            : classes.statusHeaderCell
        }
      >
        <div
          className={classes.customerName}
          onClick={() => unAssignDriver(stopData)}
        >
          Click to unassign
        </div>
      </TableCell>
    </TableRow>
  );
};

export default withStyles(styles)(UnAssignPickup);
